import React, { useEffect } from 'react';
import { config } from '../../services/Constants/AppConstants';
import { redirectToAppWithFallback } from '../../utils';
import './MobileSuccessCheckout.scss';

interface MobileSuccessCheckoutProps {
  webRedirectUrl?: string;
}

export const MobileSuccessCheckout: React.FC<MobileSuccessCheckoutProps> = ({ webRedirectUrl }) => {
  useEffect(() => {
    redirectToAppWithFallback(config.MOBILE_SUCCESS_CHECKOUT_REDIRECT, webRedirectUrl);
  }, [webRedirectUrl]);

  return (
    <div className="mobile-success-checkout">
      <div className="success-content">
        <div className="success-icon">
          <svg
            width="120"
            height="120"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 40L35 55L60 25"
              stroke="#50A682"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="success-message">
          Your transaction has been completed successfully. We have emailed you the details of your
          order.
        </p>
      </div>
    </div>
  );
};
